class StrikemanBlogPage extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-blog-card]'));
    this.filterControls = Array.from(this.querySelectorAll('[data-blog-filter]'));
    this.topicTriggers = Array.from(this.querySelectorAll('[data-blog-topic-trigger]'));
    this.searchInput = this.querySelector('[data-blog-search-input]');
    this.noResults = this.querySelector('[data-blog-no-results]');
    this.articleRegion = this.querySelector('[data-blog-results-region]');
    this.faqInput = this.querySelector('[data-blog-faq-search]');
    this.faqItems = Array.from(this.querySelectorAll('[data-blog-faq-item]'));
    this.helpInput = this.querySelector('[data-blog-help-search]');
    this.helpCards = Array.from(this.querySelectorAll('[data-blog-help-card]'));
    this.helpNoResults = this.querySelector('[data-blog-help-no-results]');
    this.validTopics = new Set(this.filterControls.map((control) => control.dataset.blogFilter || 'all'));

    const params = new URLSearchParams(window.location.search);
    const requestedTopic = params.get('topic');
    this.activeTopic = this.validTopics.has(requestedTopic) ? requestedTopic : (params.get('q') ? 'all' : 'start-here');

    if (this.searchInput && params.get('q')) {
      this.searchInput.value = params.get('q');
    }

    this.filterControls.forEach((control) => {
      control.addEventListener('click', () => {
        this.setTopic(control.dataset.blogFilter || 'all', true);
      });
    });

    this.topicTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.setTopic(trigger.dataset.blogTopicTrigger || 'all', true);
        this.articleRegion?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    this.searchInput?.addEventListener('input', () => {
      this.applyFilters(true);
    });

    this.faqInput?.addEventListener('input', () => {
      this.filterFaqs();
    });

    this.helpInput?.addEventListener('input', () => {
      this.filterHelpCards();
    });

    this.applyFilters(false);
  }

  setTopic(topic, updateUrl) {
    this.activeTopic = topic || 'all';
    this.applyFilters(updateUrl);
  }

  applyFilters(updateUrl) {
    const query = (this.searchInput?.value || '').trim().toLowerCase();
    let visibleCount = 0;

    this.cards.forEach((card) => {
      const topics = (card.dataset.blogTopics || '').split(/\s+/).filter(Boolean);
      const searchable = (card.dataset.blogSearch || '').toLowerCase();
      const matchesTopic = this.activeTopic === 'all' || topics.includes(this.activeTopic);
      const matchesQuery = query === '' || searchable.includes(query);
      const isVisible = matchesTopic && matchesQuery;

      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    this.filterControls.forEach((control) => {
      const isActive = (control.dataset.blogFilter || 'all') === this.activeTopic;
      control.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.topicTriggers.forEach((trigger) => {
      const isActive = (trigger.dataset.blogTopicTrigger || 'all') === this.activeTopic;
      trigger.toggleAttribute('data-active', isActive);
      if (isActive) {
        trigger.setAttribute('aria-current', 'true');
      } else {
        trigger.removeAttribute('aria-current');
      }
    });

    if (this.noResults) {
      this.noResults.hidden = visibleCount !== 0;
    }

    if (updateUrl) {
      this.updateUrl(query);
    }
  }

  updateUrl(query) {
    const url = new URL(window.location.href);

    if (this.activeTopic === 'all') {
      url.searchParams.delete('topic');
    } else {
      url.searchParams.set('topic', this.activeTopic);
    }

    if (query) {
      url.searchParams.set('q', query);
    } else {
      url.searchParams.delete('q');
    }

    url.hash = 'featured-articles';
    window.history.replaceState({}, '', url);
  }

  filterFaqs() {
    const query = (this.faqInput?.value || '').trim().toLowerCase();

    this.faqItems.forEach((item) => {
      const text = (item.dataset.blogFaqItem || item.textContent || '').toLowerCase();
      item.hidden = query !== '' && !text.includes(query);
    });
  }

  filterHelpCards() {
    const query = (this.helpInput?.value || '').trim().toLowerCase();
    let visibleCount = 0;

    this.helpCards.forEach((card) => {
      const text = (card.dataset.blogHelpCard || card.textContent || '').toLowerCase();
      const isVisible = query === '' || text.includes(query);

      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (this.helpNoResults) {
      this.helpNoResults.hidden = visibleCount !== 0;
    }
  }
}

if (!customElements.get('strikeman-blog-page')) {
  customElements.define('strikeman-blog-page', StrikemanBlogPage);
}
